// The currency filter of an embedded dashboard (ANS-664). It holds the picked
// and the applied currency and makes every setFilters call on the SDK handle,
// one request at a time: the SDK promises no order of outcomes and its events
// name no request, so with one outstanding every outcome belongs to it. A pick
// made meanwhile waits; when the request settles the newest pick is sent if it
// differs from the applied currency. Imports nothing, so it is tested alone.

// The currency filter's name in the dashboards' filter bar: 'Ccy' (decided
// 25 Oct, delegated by Charlie). It is the name TP ICAP already uses: the
// worksheets' dashboard-currency column (worksheet-fi and worksheet-fx-spot in
// tests/acceptance/jitto-answer/tca/mock-import/bundle/03-worksheets/), the
// UOB report filter {col1: "Ccy", op1: "EQ", val1: "SGD"} and the capture
// targets (tests/acceptance/jitto-answer/tca/capture/). Each Jitto dashboard
// needs a native filter named exactly 'Ccy'.
export const CURRENCY_FILTER = 'Ccy';
// No saved currency: SGD, the user-preferences fallback (ANS-795).
export const DEFAULT_CURRENCY = 'SGD';

// `filtered` false: the dashboard is not filtered by currency (host filters off, or
// a dashboard with no Ccy filter, which Jitto refuses as an unknown name and fails
// the whole frame: jitto-analyze#540). Then `mount` is undefined and nothing is sent.
export function createCurrencyFilter({
  saved,
  filtered = true,
  log = console.error,
  onChange = () => {},
} = {}) {
  let applied = saved || DEFAULT_CURRENCY; // what the dashboard is filtered by
  let picked = applied; // the newest pick; the picker shows it
  let outstanding = false; // one setFilters call not yet settled
  let handle = null;
  let failed = false;
  const mount = filtered ? Object.freeze({ [CURRENCY_FILTER]: applied }) : undefined;

  function sendNewest() {
    if (!filtered || !handle || failed || outstanding || picked === applied) return;
    const currency = picked;
    outstanding = true;
    handle.setFilters({ [CURRENCY_FILTER]: currency }).then(
      () => {
        outstanding = false;
        applied = currency;
        sendNewest();
        onChange();
      },
      (error) => {
        outstanding = false;
        log(error);
        // Nothing picked since: the picker goes back to what is applied.
        if (picked === currency) picked = applied;
        sendNewest();
        onChange();
      },
    );
  }

  return {
    mount,
    attach(next) {
      handle = next;
      sendNewest();
    },
    pick(currency) {
      if (failed || !currency) return;
      picked = currency;
      sendNewest();
      onChange();
    },
    mountFailed(event) {
      log(event);
      failed = true;
      onChange();
    },
    picker: () => picked,
    currency: () => applied,
    failed: () => failed,
  };
}
